import { useQuery } from '@tanstack/react-query'

import { fetchBvaDetails } from 'api/fetchers/fetchBvaDetails'

export const useBvaDetails = (id?: string) =>
  useQuery({
    queryKey: ['bvaDetails', id],
    queryFn: async ({ signal }) => (await fetchBvaDetails(id as string)(signal)).data,
    enabled: !!id,
  })
